// extracted by mini-css-extract-plugin
var _1 = "EmailRecipientsSelectDropdownHeader-moduleEmailRecipientsSelectDropdownHeader__NL8HP";
export { _1 as "EmailRecipientsSelectDropdownHeader" }
